// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GeneralObject } from "@vocollege/app/dist/global";
import {
  DownloadExcelButtonProps,
  Sheet,
} from "@vocollege/components/dist/DownloadExcelButton";

export const getStepLabel = (mod: string) => {
  let modString = I18n.get.tutorCertificate.modules.find(
    (v: GeneralObject) => v.name === mod,
  );
  return modString?.label || "";
};

export const getExcelData = (
  data: any,
  parsedData: any,
  variables: any,
  state: any,
) => {
  if (parsedData.length === 0) {
    return null;
  }
  const result: DownloadExcelButtonProps = {
    filename: I18n.get.tutorCertificate.label,
    sheets: [],
  };
  let commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: I18n.get.tutorCertificate.label,
          },
        ],
      },
      "",
      `${I18n.get.misc.created_at} ${data?.certStatisticsTutorCertificates.createdAt}\n${variables?.from} - ${variables?.to}`,
    ],
    [],
    [],
    [
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: I18n.get.vocertStatistics.total,
          },
        ],
      },
      "",
      state.total,
    ],
  ];

  let summarySheet: Sheet = {
    name: I18n.get.vocertStatistics.summary,
    rows: [...commonHead],
  };

  // Steps.

  summarySheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 10,
          },
          text: I18n.get.vocertStatistics.steps.step1,
        },
      ],
    },
    "",
    state.totalStep1,
  ]);

  summarySheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 10,
          },
          text: I18n.get.vocertStatistics.steps.step2,
        },
      ],
    },
    "",
    state.totalStep2,
  ]);

  summarySheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 10,
          },
          text: I18n.get.vocertStatistics.steps.step3,
        },
      ],
    },
    "",
    state.totalStep3,
  ]);

  // Step 2 modules.

  summarySheet.rows?.push(["", "", ""]);
  summarySheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 10,
            bold: true,
          },
          text: I18n.get.tutorCertificate.labels.step2Modules,
        },
      ],
    },
    "",
    "",
  ]);
  summarySheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 8,
          },
          text: getStepLabel("step2-mod01"),
        },
      ],
    },
    "",
    state["step2-mod01"],
  ]);
  summarySheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 8,
          },
          text: getStepLabel("step2-mod02"),
        },
      ],
    },
    "",
    state["step2-mod02"],
  ]);
  summarySheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 8,
          },
          text: getStepLabel("step2-mod03"),
        },
      ],
    },
    "",
    state["step2-mod03"],
  ]);
  summarySheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 8,
          },
          text: getStepLabel("step2-mod04"),
        },
      ],
    },
    "",
    state["step2-mod04"],
  ]);

  result.sheets?.push(summarySheet);

  let byGroupSheet: Sheet = {
    name: I18n.trans(I18n.get.vocertStatistics.perItem, {
      item: I18n.get.group.categories.region.toLowerCase(),
    }),
    rows: [...commonHead],
  };

  parsedData.forEach((v: GeneralObject) => {
    byGroupSheet.rows?.push(["", "", ""]);
    byGroupSheet.rows?.push([
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: v.title,
          },
        ],
      },
      "",
      v.total,
    ]);

    v.steps.forEach((v: GeneralObject) => {
      byGroupSheet.rows?.push([
        {
          richText: [
            {
              font: { size: 8 },
              text: I18n.get.vocertStatistics.steps[v.step],
            },
          ],
        },
        "",
        v.total,
      ]);
    });

    if (v.step2 && v.step2.length > 0) {
      byGroupSheet.rows?.push([
        {
          richText: [
            {
              font: { size: 8, bold: true },
              text: I18n.get.tutorCertificate.labels.step2Modules,
            },
          ],
        },
        "",
        "",
      ]);

      v.step2.forEach((v: GeneralObject) => {
        byGroupSheet.rows?.push([
          {
            richText: [
              {
                font: { size: 8 },
                text: getStepLabel(v.mod),
              },
            ],
          },
          "",
          v.total,
        ]);
      });
    }
  });

  result.sheets?.push(byGroupSheet);

  return result;
};
